export enum PublicRoute {
  Home = '/',
}

export enum PrivateRoute {
  MemberDashboard = '/member/dashboard',
  MemberVendorProjects = '/member/vendors/:vendorId/projects',
  VendorDashboard = '/vendor/dashboard',
  VendorDashboardProjects = '/vendor/dashboard/:representativeId',
  Connection = '/connection',
  ProjectConnection = 'vendor/:representativeId/project/:projectId/connection',
}

export enum OutletRoute {
  AddCertificate = 'add-certificate',
  SetUpScript = 'set-up-script',
  TestConnection = 'test-connection',
  TestPayload = 'test-payload',
}
